<template>
  <div class="home">
    <img class="home__bg" :src="images.bg" />
    <div class="home__container">
      <div class="headerContainer">
        <div class="home__header">
          <span class="leftView">
            <img class="back" src="@/assets/goClass.png" @click="goBack()" />
            <!-- <span class="top">
              <img class="icon" :src="images.message_icon" />
              App Store精选
            </span> -->
            <span class="topButton" @click="goWebSite('/index/TaskList')">作业中心</span>
            <span class="topButton" @click="goWebSite('https://oj.coding61.com/')">橙子竞赛</span>
            <span class="topButton" @click="jumpToProfile()">个人主页</span>
          </span>

          <!-- <img class="title" :src="images.title" /> -->
          <span class="home__message">
            <span v-if="postType === 'common'" class="sendPost" @click.stop="openQuestionView()">出题</span>
            <span v-if="['common', 'piskel', 'lego'].includes(postType)" class="sendPost" @click.stop="openInputView()">发帖</span>
            <span v-if="postType === 'cube'" class="sendPost" @click.stop="openInputView()">发表</span>
            <span v-if="postType === 'video'" class="sendPost" @click.stop="openInputView()">发布</span>
            <!-- <img :src="images.message_icon" /> -->
            <span class="sendPost" @click.stop="jumpToMessage()">消息 <span class="home__message__count" v-if="message && message.unread_total_count > 0">{{ message.unread_total_count }}</span></span>
            <span class="logout" @click.stop="quit()" v-if="loginStatus">退出</span>
            <span class="logout" @click.stop="login()" v-else>登录</span>
          </span>
            
        </div>
      </div>
     
      <div style="font-size:16px;color:#fff000;margin-bottom:5px;" class="scratchallwork">
        <span>Scratch精选作品</span>
        <div class="workBtn" @click="jumpToAllWorks()">
          <span>全部作品</span>
          <img :src="images.scratch_all_works" alt="图片加载失败">
        </div>
      </div>
      <WorkListTop tag="scratch3" />
      <!-- <WorkListTop tag="applab" /> -->
      <div class="home__topContainer">
        <div class="inputViewContainerShadow" v-if="show_input_shadow">
          <div class="inputViewContainer">
            <InputView type="post" :post-type="postType"/>
            <span class="close" @click="hideInputView()">
              <span class="line1"></span>
              <span class="line2"></span>
            </span>
          </div>
        </div>
        <div class="userInfoContainer" v-if="!rightNotArr.includes(postType)">
          <div class="userInfoContainer__avatar" @click="jumpToProfile()">
            <img class="userInfoContainer__avatar__bg" v-if="message && message.segment && message.segment.image" :src="getImg(message.segment.image)" />
            <img class="userInfoContainer__avatar__img" v-if="userInfo && userInfo.avatar" :src="getImg(userInfo.avatar)" />
            <img class="userInfoContainer__avatar" style="margin-top:0;" v-if="!loginStatus" :src="images.default_avatar" />
          </div>
          <div class="userInfoContainer__text" v-if="loginStatus">
            <span class="userInfoContainer__name" @click="jumpToProfile()">{{
              userInfo ? userInfo.name : ""
            }}</span>
            <span class="userInfoContainer__segment" v-if="message && message.segment && message.segment.name">[{{ message && message.segment && message.segment.name }}]</span>
          </div>
          <span class="userInfoContainer__text" v-if="!loginStatus">游客</span>
          <div class="userinfo__intro">
            <span class="userinfo__intro__item">{{
                message && message.segment && message.segment.prestige_number
                  ? message.segment.prestige_number
                  : 0
              }}<br />声望
            </span>
            <span class="userinfo__intro__line"></span>
            <span class="userinfo__intro__item">{{
                message && message.segment && message.segment.flower_number
                  ? message.segment.flower_number
                  : 0
              }}<br />小花
            </span>
            <span class="userinfo__intro__line"></span>
            <span class="userinfo__intro__item">{{
                message && message.segment && message.segment.diamond
                  ? message.segment.diamond
                  : 0
              }}<br />蓝钻
            </span>
          </div>
        </div>
      </div>
      <div class="home__mainContainer">
        <div class="leftView">
          <Capillaries :post-type="postType"/>
        </div>

        <div class="home__leftContainer__content">
          <CompanyList v-if="postType === 'company' " />
          <Diary v-else-if="postType === 'diary' " />
          <ScratchHome v-else-if="postType === 'scratch' " />
          <AppStoreHome v-else-if="postType === 'appstore' "/>
          <CodeQA v-else-if="postType === 'codeQA' "/>
          <ActivityHome v-else-if="postType === 'active' "/>
          <SchoolHome v-else-if="postType === 'mentor'" />
          <LegoHome v-else-if="postType === 'legocommunity' "/>
          <template v-else-if="postType !== ''">
            <div class="headerView" v-if="postType === 'common' || postType=== 'work' || postType=== 'lego'">
              <!-- 全部/关注 -->
              <div class="tabs">
                <span :class="`tab ${followType === 'all' ? 'tab--select' : ''}`" @click="setFollowType('all')">全部</span>
                <span :class="`tab ${followType === 'follow' ? 'tab--select' : ''}`" @click="setFollowType('follow')">关注</span>
              </div>
              <!-- <template v-if="userInfo.is_staff === false">
              <DayTimer/>
            </template> -->

              <!-- 粉丝数 -->
              <div class="follower">
                <span class="follow item" @click="goMyFollower('follow')">
                  <span class="number">{{message&&message.follow_count?message.follow_count:0}}</span>
                  <span>关注</span>
                </span>
                <span class="fan item" @click="goMyFollower('fan')">
                  <span class="number">{{message&&message.fan_count?message.fan_count:0}}</span>
                  <span>粉丝</span>
                </span>
              </div>
              <!-- 搜索框 -->
              <div class="searchView">
                <div v-if="searchView.show" class="input rightAnimate"><input v-model="searchView.content"/></div>
                <img class="icon" :src="images.search" @click.stop="openSearchView()"/>
              </div>
            
            </div>
            <p class="rule" v-if="postType === 'common'">社区新规：允许争论，禁止骂人，未经允许不得使用ta人头像，使用别人作品创作请用Remix功能。否则将会被扣声望，严重的禁言处理。</p>

            <PostList ref="postList" :post-type="postType" :follow-type="followType" :owner-info="userInfo" />
          </template>
        </div>
        <div class="rightView" v-if="!rightNotArr.includes(postType)">
          <CompanyRank v-if="postType === 'company' " />
          <PopularityRank v-else />
        </div>
      </div>
    </div>
    <img class="backTop" :src="images.back_top" @click="backTopEvent" v-if="back_top" />
    <!-- 输入密码 -->
    <div class="mask" v-if="false">
      <div class="enterPw">
        <div class="title">请{{pwType == 'input'?'输入':pwType == 'reset'?'重置':'确认'}}日记密码</div>
        <div class="box">
          <input ref="pwInput" v-model="diaryPw" type="number" maxlength="4" />
          <div class="pw" @click="focusPwInput()">
            <div :class="{active:diaryPw.length ==0}">
              <span v-show="diaryPw.length > 0"></span>
            </div>
            <div :class="{active:diaryPw.length ==1}">
              <span v-show="diaryPw.length > 1"></span>
            </div>
            <div :class="{active:diaryPw.length ==2}">
              <span v-show="diaryPw.length > 2"></span>
            </div>
            <div :class="{active:diaryPw.length ==3}">
              <span v-show="diaryPw.length > 3"></span>
            </div>
          </div>
          <div class="resetPw" @click="resetPw()">
            重置密码
          </div>
        </div>
      </div>
    </div>
    <!-- 新建习题组件 -->
    <CreateQuestion ref="createCompany" tag="shadow">
      <CreateQuestion />
    </CreateQuestion>

    <!-- 用户引导图 -->
    <UserGuide v-if="show_user_guide"/>
  </div>
</template>

<script>
// @ is an alias to /src
import InputView from "./components/InputView.vue";
import PopularityRank from "./PopularityRank.vue";
import PostList from './PostList.vue';
import CompanyList from './CompanyList.vue';
import CompanyRank from './CompanyRank.vue';
import WorkListTop from './WorkListTop.vue'
import CodeQA from './CodeQA.vue'
import CreateQuestion from './components/CreateQuestion.vue'
import Diary from './Diary.vue'
import Capillaries from './components/Capillaries.vue'
import ScratchHome from './scratch/Home.vue'
import AppStoreHome from './AppStoreHome.vue'
import UserGuide from './components/UserGuide.vue'
import ActivityHome from './activity/Home.vue'
import SchoolHome from './school/SchoolList.vue'
import LegoHome from './lego/Home.vue'

import { types as CommunityTypes } from "@/store/modules/community";
import { types as LoginTypes } from "@/store/modules/login";
import { types as BrandTypes } from "@/store/modules/brand";
import { types as ToastTypes } from "@/store/modules/toast";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

import {
  TITLE,
  BG,
  AVATAR_BG,
  BRAND_ICON,
  IMG_BACK,
  IMG_MESSAGE_ICON,
  IMG_OJ_ICON,
  IMG_WORK_ICON,
  IMG_FRIEND_ICON,
  IMG_COMPANY_ICON,
  IMG_BACK_TOP,
  IMG_BANNER,
  IMG_SEARCH,
  IMG_DEFAULT_AVATAR,
  IMG_SCRATCH_ALL_WORKS
} from "@/assets";
import { Utils, GET_VALUE, REMOVE_VALUE } from "@/utils";
// import DayTimer from "./components/DayTimer"

export default {
  name: "home",
  components: {
    InputView,
    PopularityRank,
    PostList,
    CompanyList,
    CompanyRank,
    WorkListTop,
    CreateQuestion,
    Diary,
    Capillaries,
    ScratchHome,
    AppStoreHome,
    UserGuide,
    CodeQA,
    ActivityHome,
    SchoolHome,
    LegoHome
    // DayTimer
  },
  data () {
    return {
      images: {
        title: TITLE,
        bg: BG,
        avatar_bg: AVATAR_BG,
        brand_icon: BRAND_ICON,
        back: IMG_BACK,
        message_icon: IMG_MESSAGE_ICON,
        oj_icon: IMG_OJ_ICON,
        work_icon: IMG_WORK_ICON,
        friend_icon: IMG_FRIEND_ICON,
        company_icon: IMG_COMPANY_ICON,
        back_top: IMG_BACK_TOP,
        banner: IMG_BANNER,
        search: IMG_SEARCH,
        default_avatar: IMG_DEFAULT_AVATAR,
        scratch_all_works:IMG_SCRATCH_ALL_WORKS
      },
      can_goback: window.history.length > 1 ? true : false,
      postType: "",
      followType: "all",
      back_top: false,
      show_input_shadow: false,
      rightNotArr:['scratch','codeQA','legocommunity'],//右边不显示的postType

      // searchView
      searchView:{
        show: false,
        content: ''
      },

      //日记相关
      showDiary: false,
      diaryPw: "",
      pwType: 'input',//reset 重置密码，confirm确认密码,input输入密码

      // 用户引导
      show_user_guide: false
    };
  },
  watch:{
    watch_can_send(value){
      console.log(value);
      let response = value
      if(!response.can_send){
        this.showToast({message:"15分钟内只能发一条帖子"})
        return
      }
      if(response.tag === "post"){
        this.show_input_shadow = true;
      }if(response.tag === "problem"){
        this.$refs.createCompany.showShadowView();
      }
    }
  },
  computed: {
    ...mapState({
      loginStatus: state => state.login.status,
      userInfo: state => state.login.userInfo,
      message: state => state.login.message,
      current_ad: state => state.video_course.current_ad,
      watch_can_send: state => state.community.watch_can_send
    })
  },

  methods: {
    ...mapMutations({
      showToast: ToastTypes.SHOW,
      updateNewPostCount: CommunityTypes.UPDATE_NEW_POST_COUNT
    }),
    ...mapActions({
      dependLoginStatus: LoginTypes.LOAD_LOGIN_STATUS,
      fetchLogin: LoginTypes.FETCH_LOGIN,
      fetchLogout: LoginTypes.FETCH_LOGOUT,
      fetchOwnInfo: LoginTypes.FETCH_USERINFO,
      fetchUnreadMessage: LoginTypes.FETCH_UNREAD_MESSAGE,
      fetchCreateEvent: CommunityTypes.FETCH_CREATE_EVENT,
      fetchNewPostCount: CommunityTypes.FETCH_NEW_ADD_POST_COUNT,
      fetchIsCanSend: CommunityTypes.FETCH_IS_CAN_SEND
    }),
    ...Utils,
    // 返回事件
    goBack () {
      // 登录状态判断
      this.dependLoginStatus().then(()=>{
        location.href = "/index/CogaSelect"
      })
    },
    // 我的关注列表
    goMyFollower(type){
      let callback = () => {
      this.$router.push(`/myfollower?type=${type}`);
      }
      this.dependLoginStatus().then(callback)
    },
    // 设置帖子类型
    setPostType (type) {
      // 切换 tab，刷新右上角消息数和左边圈子未读数
      this.fetchNewPostCount();
      this.fetchUnreadMessage();

      if (type === this.postType) return;
      
      this.postType = type;
      this.$router.replace(`/?tag=${type}`);
      if(['company'].includes(type)){
        console.log("公司圈未读数置为0")
        this.updateNewPostCount({"company_count":0});
      }else if (["diary", "appstore", "scratch"].includes(type)) {
        // 公司圈的话，刷新新增帖子个数, 
        this.fetchNewPostCount();
      } else if (['work', 'common', 'contest', 'science', 'move', 'mago', 'cube', 'video', 'piskel', 'lego'].includes(type)) {
        if (this.$refs.postList) {
          console.log("改变了帖子的类型：重新请求", type)
          this.$refs.postList.loadData("reset", type, this.followType)
        }
      }

    },
    // 设置帖子关注类型
    setFollowType (type) {
      let callback = () => {
      this.followType = type;
      if (this.$refs.postList) {
        console.log("改变了关注的类型：重新请求", type)
        this.$refs.postList.loadData("reset", this.postType, type)
      }
      }
      if(type === 'follow'){
        this.dependLoginStatus().then(callback)
      }else{
        callback()
      }
    },
    // 跳到个人主页
    jumpToProfile (tag) {
      let callback = () => {
      if (!tag) {
        tag = "post";
      }
      let user_id = this.userInfo.user_id;
      // this.$router.push(`/profile/${owner}`);                     //方式 0   /profile/123
      // this.$router.push({name:'profile', params:{user:owner}});   //方式 1   /profile/123
      // this.$router.push({path: `/profile/${owner}`});             //方式 2   /profile/123
      // this.$router.push({path: 'profile', query:{user:owner}});   //方式 3   /profile?user=123
      // this.$router.push({path:'/profile', params:{user:owner}});  //这种的 params 无效

      this.$router.push(`/profile/${user_id}?tag=${tag}`);
      // this.$router.push({path:`/profile/${user_id}/`, query:{tag:tag}})
      }
      // 登录状态判断
      this.dependLoginStatus().then(callback)
    },
    // 跳到消息中心页
    jumpToMessage () {
      // 登录状态判断
      this.dependLoginStatus().then(()=>{
        this.$router.push(`/message`);
      })
    },
    // 跳到全部作品页
    jumpToAllWorks(){
      this.$router.push(`/scratch/allworkscontainer`)
    },
    // 退出登录
    quit(){
      REMOVE_VALUE("Token")
      REMOVE_VALUE("face2face_token")
      REMOVE_VALUE("username")
      REMOVE_VALUE("ownerInfo")
      REMOVE_VALUE("Token", 'cookie')
      // location.reload()
      this.$router.go(0);
      // this.fetchLogout();
    },
    // 登录
    login(){
      let newUrl = location.href
      location.href = `/index/Login?ret=${newUrl}`
    },
    // 去其他网页
    goWebSite (url) {
      if(url.includes("TaskList")){
        // 登录状态判断
        this.dependLoginStatus().then(()=>{
          window.open(url, '_blank')
        })
      }else{
        window.open(url, '_blank')
      }
    },
    // 回到顶部
    backTopEvent () {
      document.documentElement.scrollTop = 0
    },
    // 监听滚动事件
    handleScroll(e) {
      var that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      
      // if(e && e.target){
      //   scrollTop = e.target.scrollTop
      // }

      if (scrollTop > 0) {
        // 显示回到顶部按钮
        this.back_top = true;
      } else {
        // 隐藏回到顶部按钮
        this.back_top = false;
      }
    },
    // 打开帖子输入框
    openInputView () {
      let callback = ()=>{
        // this.show_input_shadow = true;
        this.fetchIsCanSend({"tag":"post"})
      }
      this.dependLoginStatus().then(callback)
    },
    hideInputView () {
      this.show_input_shadow = false
    },
    // 打开出题框
    openQuestionView () {
      let callback = ()=>{
        // this.$refs.createCompany.showShadowView();
        this.fetchIsCanSend({"tag":"problem"})
      }
      this.dependLoginStatus().then(callback)
    },
    // 搜索按钮点击事件
    openSearchView(){
      if(this.searchView.show){
        // 调搜索 api
        if (this.$refs.postList) {
          console.log("按帖子内容进行搜索：重新请求", this.searchView.content)
          this.$refs.postList.loadData("reset", this.postType, this.followType, this.searchView.content)
          this.searchView.content = ""
          this.searchView.show = false;
        }
      }else{
        // 打开搜索框
        this.searchView.show = !this.searchView.show;
      }
    },

    //-------------inputView 组件的回调函数
    //发帖子
    publish (type, data) {
      data["type"] = type;
      // console.log(data);
      this.fetchCreateEvent(data);
      this.hideInputView();
    },
    
   
    // 聚焦在pwinput上
    focusPwInput () {
      if (this.diaryPw.length > 3) {
        this.diaryPw = this.diaryPw.substr(0, 3)
      }
      this.$refs.pwInput.focus();
    },
    // 重置密码相关
    resetPw () {
    }
  },
  created () {
    window.addEventListener("scroll", this.handleScroll);


  },
  destroyed () {
    window.removeEventListener("scroll", this.handleScroll);
  },
  mounted () {
    if(GET_VALUE('user_guide')){
      this.show_user_guide = false
    }else{
      this.show_user_guide = true
    }
    if (this.$route.query.tag) {
      this.postType = this.$route.query.tag;
    } else {
      this.postType = "scratch";
    }
    this.fetchNewPostCount();
    if(this.loginStatus){
    this.fetchOwnInfo();
    this.fetchUnreadMessage();
    }
  }
};
</script>

<style lang="less" scoped>
.home {
  background-color: #6b45e1;
  width: 100%;
  /* height: 100%; */
  min-width: 1100px;
  min-height: 100%;

  /* background-position: center; */
  /* background-repeat: no-repeat; */
  background-size: 100%;
  position: relative;
  .scratchallwork{
    display: flex;
    justify-content: space-between;
    .workBtn{
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor:pointer;
      span{
        font-size:16px;
        margin-right:3px;
      }
      img{
        width: 16px;
        height: 16px;
      }
    }
  }
}
.home__bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}
.home__container {
  width: 1000px;
  /* min-height: 100%;
  min-height: 680px; */
  /* height: 100%; */
  margin: 0 auto;
  // padding-top: 30px;
  padding-bottom: 30px;
  /* background-color: red; */

  /* display: flex;
  flex-direction: column; */
  z-index: 200;
  position: relative;
}
.home__header {
  color: #ff6600;
  font-size: 40px;
  /* text-align: center; */
  height: 44px;
  line-height: 44px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 5px;
  .leftView {
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-grow: 1;
    .topButton {
      font-size: 18px;
      color: #ffffff;
      display: inline-block;
      margin-left: 40px;
      cursor: pointer;
    }
  }
  .back {
    height: 44px;
    cursor: pointer;
  }
  .top {
    margin-left: 15px;
    font-size: 15px;
    color: #ffffff;
    display: flex;
    flex-direction: row;
    align-items: center;
    .icon {
      height: 20px;
      margin-right: 5px;
    }
  }
  .title {
    height: 44px;
  }
  .home__message {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 15px;
    color: #ffffff;
    cursor: pointer;
  }
  .home__message img {
    width: 20px;
    margin-right: 5px;
  }
  .home__message__count {
    margin-left: 5px;
    min-width: 18px;
    height: 13px;
    line-height: 14px;
    text-align: center;
    display: inline-block;
    padding: 0 2px;
    color: #fff;
    border-radius: 3px;
    background-color: #ff6600;
    font-size: 8px;
  }
  .sendPost {
    margin-right: 40px;
  }
  .logout{
    font-size: 15px;
    background: #ffffff;
    color: #FF7B00;
    border-radius: 15px;
    text-align: center;
    /* display: flex; */
    height: 25px;
    line-height: 25px;
    width: 50px;
  }
}

.home__topContainer {
  display: flex;
  flex-direction: row;
  height: 210px;
  .inputViewContainerShadow {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 300;
    position: fixed;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    .inputViewContainer {
      width: 770px;
      position: relative;
      .close {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background-color: #ffffff;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        position: absolute;
        right: -50px;
        top: 0;
        transform: rotate(45deg);
        .line1 {
          position: absolute;
          width: 20px;
          height: 1.5px;
          background-color: #644ed9;
          top: calc(50% - 1px);
        }
        .line2 {
          width: 1.5px;
          height: 20px;
          background-color: #644ed9;
        }
      }
    }
  }
  .userInfoContainer {
    width: 220px;
    height: 200px;
    background-color: white;
    border-radius: 5px;
    margin-bottom: 10px;
    margin-left: 10px;
    overflow: hidden;

    margin-left: calc(100% - 220px);
  }
}
.home__mainContainer {
  display: flex;
  flex-direction: row;
  .leftView {
    width: 132px;
    background-color: #f4f3f3;
    border-radius: 5px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    position: relative;
    padding-top: 10px;
    margin-top: -210px;
  }
  .home__leftContainer__content {
    background-color: white;
    border-radius: 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    flex: 1;
    width: calc(100% - 350px);
    min-height: 500px;

    margin-top: -210px;
    .headerView{
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position: relative;
      margin: 15px 0;
      .tabs {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        // padding-top: 18px;
        // margin-left: -120px;
        .tab {
          color: #666666;
          font-size: 15px;
          margin-left: 15px;
          margin-right: 15px;
          padding-bottom: 3px;
          cursor: pointer;
        }
        .tab--select {
          color: #ff7b00;
          border-bottom: solid 1.5px #f56501;
          font-weight: bold;
        }
      }
      .follower {
        position: absolute;
        // top: 10px;
        display: flex;
        flex-direction: row;
        // right: 0;
        left: 20px;
        .item {
          margin-right: 20px;
          display: flex;
          flex-direction: column;
          font-size: 12px;
          color: #999999;
          text-align: center;
          cursor: pointer;
          .number {
            color: #6b45e1;
          }
        }
      }
      .searchView{
        position: absolute;
        // top: 10px;
        display: flex;
        flex-direction: row;
        right: 10px;
        align-items: center;
        .input{
          flex: 1;
          border: solid 1px #6F56DD;
          border-radius: 20px;
          padding: 2px;
          padding-left: 10px;
          padding-right: 22px;
          overflow: hidden;
          &.rightAnimate{
            animation: rightEaseinAnimate 1s ease 1;
          }
          input{
            border: none;
            width: 100%;
            height: 100%;
            background-color: transparent;
          }
        }
        .icon{
          height: 15px;
          position: absolute;
          right: 5px;
          cursor: pointer;
        }
      }
    }
    .rule{
      background-color: #F4F3F3;
      color: #6B45E1;
      font-size: 14px;
      border: dotted 1px #6B45E1;
      margin: 10px 15px;
      padding: 5px 10px;
      border-style: dashed;
      border-radius: 5px;
      line-height: 24px;
    }
  }
  .rightView {
    width: 220px;
    margin-left: 10px;
  }
}
.userInfoContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.userInfoContainer__avatar {
  position: relative;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  cursor: pointer;
  height: 75px;
}
.userInfoContainer__avatar__bg {
  /* height: 80px; */
  height: 100%;
  position: relative;
  z-index: 100;
}
.userInfoContainer__avatar__img {
  position: absolute;
  top: 15px;
  left: calc((100% - 50px) / 2 + 1px);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  z-index: 99;
}
.userInfoContainer__text {
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}
.userInfoContainer__name {
  color: #333333;
  font-weight: 700;
  cursor: pointer;
  font-size: 14px;
  margin-right: 5px;
  line-height: 20px;
  height: 20px;
  overflow: hidden;
  flex: 1;
}
.userInfoContainer__segment {
  /* color: #5F0AFF; */
  /* font-size: 12px; */
  color: #666666;
  font-size: 11px;
  margin-left: 3px;
  font-weight: normal;
}
.userinfo__intro__work:hover,
.userinfo__intro__post:hover,
.userInfoContainer__name:hover {
  color: #eb7350;
}
.userinfo__intro {
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  align-items: center;
  font-size: 13px;
  color: #666666;
  text-align: center;
  width: calc(100% - 20px);
  justify-content: space-around;
  padding: 0 10px;
}
.userinfo__intro__work,
.userinfo__intro__post {
  cursor: pointer;
}
.userinfo__intro__line {
  width: 1px;
  height: 10px;
  background-color: #ff6600;
  display: inline-block;
}
.backTop {
  position: fixed;
  right: 100px;
  bottom: 100px;
  width: 70px;
  z-index: 999;
  cursor: pointer;
}

// 请输入密码
.mask {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.6);
  height: 100%;
  width: 100%;
  z-index: 900;
}
.enterPw {
  width: 438px;
  background: #644ed9;
  color: #ffffff;
  font-size: 28px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 14px;
  padding: 20px;
  text-align: center;
  .box {
    margin-top: 30px;
    border-radius: 14px;
    width: 100%;
    height: 270px;
    background: #ffffff;
    position: relative;
    input {
      opacity: 0;
    }
  }
  .pw {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translate(-50%, -50%);
    padding: 0 60px;
    width: calc(100% - 120px);
    justify-content: space-between;
    div {
      width: 50px;
      height: 50px;
      border-bottom: 3px solid #644ed9;
      display: flex;
      align-items: center;

      span {
        display: block;
        height: 10px;
        width: 10px;
        border-radius: 4px;
        background: black;
        margin: 0 auto;
      }
    }
    div.active {
      border: 1px solid rgba(100, 78, 217, 0.8);
      border: 1px solid #644ed9;
      border-radius: 2px;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
        0 0 8px rgba(100, 78, 217, 0.6);
      cursor: pointer;
      span {
        border-radius: none;
        background: url("./../assets/twinkle.gif") no-repeat center center;
        background-size: contain;
        height: 30px;
      }
    }
  }
  .resetPw {
    position: absolute;
    right: 23px;
    bottom: 17px;
    font-size: 20px;
    color: #644ed9;
    cursor: pointer;
  }
}

@keyframes rightEaseinAnimate {
   0% {
      // transform: translateX(100%);
      // overflow: hidden;
      opacity: 0;
   }
   /*在0%时设置文字在想X轴-2000px位移处（左边），透明度为0，也就是看不见文字*/
   100% {
      // transform: translateX(0);
      opacity: 1;
   }
   /*在100%时设置文字在想X轴0px位移处，也就是原始布局的位置，透明度为1，也就是文字可以看见了*/
}
.ad{
  cursor: pointer; 
  margin: 10px; 
  border-radius: 5px;
  overflow: hidden;
  display: flex;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>
